import { Avatar, Tooltip } from "antd";
import type { components } from "../helper";
import { Icon } from "@iconify/react";
import { GetFullMediaPath } from "../helper/method";

export default function MessageBox({
  type,
  data,
}: {
  type: number;
  data: components["schemas"]["SiteTicketDetailMessageItem"];
}) {
  return (
    <div
      className={`flex gap-2 ${type === 2 ? "self-end" : "self-start"} flex-row-reverse w-fit`}
    >
      {type === 2 ? (
        <div>
          <Avatar size="large">L</Avatar>
        </div>
      ) : (
        ""
      )}
      <div className="flex flex-col gap-2">
        {type === 2 ? (
          <span className="text-14-regular text-left text-grayscale-600">
            {data.user_name}
          </span>
        ) : (
          ""
        )}
        <div
          className={`${
            type === 1 ? "bg-[#c8fad6]" : "bg-[#f4f6f8]"
          } p-4 rounded-2xl flex flex-col w-100`}
        >
          <div
            className="leading-6.5 text-16-regular editor"
            dangerouslySetInnerHTML={{ __html: data.message ?? "" }}
          ></div>
          <div className="flex gap-2 flex-wrap">
            {data.files?.map((e, i) => (
              <Tooltip
                key={i + "file-for-download"}
                title={e.file_name}
                className="w-fit!"
              >
                <a
                  href={GetFullMediaPath(e.file)}
                  target="_blank"
                  className="flex gap-2 text-grayscale-950! group w-fit! mt-2"
                >
                  <div className="bg-grayscale-200 rounded-2xl w-11 flex-center h-11">
                    <Icon
                      icon={"solar:file-bold-duotone"}
                      className="text-3xl"
                    />
                  </div>
                </a>
              </Tooltip>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
